import React, { useEffect, useState, useCallback } from 'react'
import "./UserProfile.css";
import ProfileSidebar from './ProfileSidebar';
import useAuth from '../../../hooks/useAuth';
import { Form, Button } from 'react-bootstrap';
import iq_api from '../../../services/iqApi';
import Alert from '../../HtmlElements/Alert';
import ScreenLoader from '../../HtmlElements/ScreenLoader';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useUser } from '../../../context/UserContext';
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from '../../../services/commonService';
import api from '../../../services/api';

export default function BusinessSegment() {
  useAuth();
  const { user } = useUser();
  const navigate = useNavigate();
  const [apiError, setApiError] = useState('');
  const [options, setOptions] = useState([]);
  var currentUrl = useLocation().pathname;
  // console.log("OPTIONS: "+JSON.stringify(options));

  var pageParsedData = getUrlDetailsObj(useLocation, useParams);

  // ++++++++++++++++++
  // GET PRODUCTS API CALL
  const fetchProducts = useCallback(async () => {
    setLoader(true);
    try {

      if(user?.company_name){
        const response = await iq_api.post("/client/products", {
          "client_name": user?.company_name,
        });

        setOptions(response?.data?.records?.products || []);
      }
      
    } catch (err) {
      setApiError(err.message || "Failed to fetch products");

    }

    const userStat = getUserStatsObject("Onboarding", "onboarding_Products", "Data: Products", currentUrl);
    pageParsedData.page_params = {
      "tab": 'business_segment'
    }
    userStat.url_details = pageParsedData;
    recordActivity(userStat);
    
    setLoader(false);
  }, []);

  useEffect(() => {
    let successMessage = sessionStorage.getItem("successMessage");
    if (successMessage) {
      sessionStorage.removeItem("successMessage"); // Clear the message
    }
    fetchProducts();
  }, [fetchProducts]);
  // ++++++++++++++++++

  const [selectedOption, setSelectedOption] = useState(null);

  const [formData, setFormData] = useState({
    newProductName: "",
    newProductDescription: ""
  });

  const [loader, setLoader] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});

  // Handle add product
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear the error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
    // console.log("ERRORS: "+JSON.stringify(errors));
  };  

  const validateForm = () => {
    let newErrors = {};

    if (formData.newProductName.trim() == ""){
      newErrors.newProductName = 'Product Name is required';
    }else if((options.find((option) => option.name.trim().toLowerCase().includes(formData.newProductName.trim().toLowerCase())))){
      newErrors.newProductName = 'Duplicate product not allowed';
    }

    if (formData.newProductDescription.trim() == ""){
      newErrors.newProductDescription = 'Product Description is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle add product
  const handleAddproduct = (e) => {

    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    let newProd = {
      /*id: 45,*/
      name: formData.newProductName,
      description: formData.newProductDescription
    };

    setOptions((options) => {
      return [...options, newProd]
    });
    setFormData({
      newProductName: "",
      newProductDescription: ""
    });
    const userStat = getUserStatsObject("Onboarding", "onboarding_Products_add", "Data: "+newProd.name, currentUrl);
    recordActivity(userStat);
  };

  const handleSelect = (index) => {
    setSelectedOption(index);
    setName(options[index].name);
    setDescription(options[index].description);
  };

  const handleDelete = (index) => {
    var array = [...options];
    if (index !== -1) {
      const userStat = getUserStatsObject("Onboarding", "onboarding_products_del", "Data: "+array[index]+"deleted", currentUrl);
      recordActivity(userStat);
      array.splice(index, 1);
      setOptions(array);
    }
    handleSelect(0);
  };

  const unsetError = () => {
    setTimeout(function(){
      setApiError('');
    }, 5000);
  }

  const handleCancel = () => {
    const userStat = getUserStatsObject("Onboarding", "cancel", "Data: Products", currentUrl);
    recordActivity(userStat);
    navigate('/user_profile/profile');
  }

  const handleSubmit =  async (e) => {
    e.preventDefault();

    const formattedData = {
      client: user?.company_name,
      products: options
    }

    setLoader(true);    
    try {

      const response = await iq_api.put('/client/update_products', formattedData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 201 || response.status === 200) {
          // sessionStorage.setItem('successMessage', response.data.result.message);
          
          const response_product_confirm = await api.post('/accounts/product_submit_confirmation', formattedData);
          if (response_product_confirm.data.status === 201 || response_product_confirm.data.status === 200) {
              // const userStat = getUserStatsObject("Onboarding", "onboarding_Products", "Data: Products", currentUrl);
              // recordActivity(userStat);
              // console.log("Email sent")

          } else {
            setApiError(response_product_confirm.data.result.message || 'An error occurred while updating the products.');
            unsetError();
          }
          
          navigate('/user_profile/company_profile');
      } else {
        setApiError(response.data.result.message || 'An error occurred while updating the products.');
        unsetError();
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'An error occurred while updating the products.';
      setApiError(errorMsg);
      unsetError();
      // console.error('Error updating the products:', error);
    }
    setLoader(false);
  }

  return (
    <div className="user_profile_wrapper pt-4 pb-4">
      <div className="container">
        <div className="user_profile_subblock">
          {apiError && <Alert type="danger" message={apiError} />}
          <div className="row">
            <div className="client_head_left">
              <h5 className="client_head">Client Admin Login</h5>
            </div>

            <div className="col-md-3">
              <div className="sidebar_profile">
                <ProfileSidebar />
              </div>
            </div>
            <div className="col-md-9">
              <div className="userprofile_right">
                {/* <div className="col-md-12"> */}
                  
                  <Form name="newProduct" className="user_form_info" style={{minHeight : '20vh'}}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="product_list_action_block">
                          <div className='row'>
                          <div className='col-md-5'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="newProductName"
                                className="form-input"
                                onChange={handleChange}
                                value={formData?.newProductName}
                                // onChange={handleChange}
                              >
                              </Form.Control>
                              <Form.Label className='form-label'>Product name <span className='red'>*</span></Form.Label>
                            </div>                            
                            {errors.newProductName && <div className="text-danger custom_error_msg">{errors.newProductName}</div>}
                          </div>
                          <div className='col-md-5'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="newProductDescription"
                                className="form-input"
                                onChange={handleChange}
                                value={formData?.newProductDescription}
                              ></Form.Control>
                              <Form.Label className='form-label'>Description <span className='red'>*</span></Form.Label>
                            </div>
                            {errors.newProductDescription && <div className="text-danger custom_error_msg">{errors.newProductDescription}</div>}
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className='col-md-12 mt-1'>
                        <div className='prev_next_block mt-1 position-relative'>
                          <Button type='button' className="next_btn_blue"
                            onClick={(e) => handleAddproduct(e)}
                          >
                            Add
                          </Button>
                          <span style={{
                            fontStyle: 'italic',
                            paddingTop: '10px',
                            color: '#64748B',
                            transition: 'all 0.3s ease',
                            fontSize: '12px',
                            fontWeight: 400
                          }}
                          >
                            ( After Clicking The ‘Add’ Button, The Product Will Be Added To The List Below. )
                          </span>
                        </div>
                      </div>
                    </div>
                  </Form>

                  <hr></hr>

                  <Form onSubmit={handleSubmit} name="existingProducts" 
                    className="user_form_info pt-2" style={{minHeight : '45vh'}}>
                      <h6 style={{fontSize: '16px', color: '#64748B'}}>PRODUCTS AND DESCRIPTION</h6>
                    {/* Product & Product Description */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="product_list_action_block">
                            <ul className="product_list_ul">
                                  {/* style={{border: '1px solid #E5E7EB', borderRadius: '8px'}}> */}
                              {options.map((option, index) => (
                                <li key={index} 
                                  className='form-control custom_list_item'
                                >
                                  <span className='mr-4 click_product' onClick={() => handleSelect(index)}>{option.name}</span>
                                  <span className='fa fa-trash mr-4' onClick={() => handleDelete(index)}></span>
                                </li>
                              ))}
                            </ul>

                        </div>
                      </div>

                      <div className="col-md-6" 
                        style={{
                          border: '1px solid #E5E7EB', 
                          borderRadius: '8px', 
                          minHeight: '35vh',
                          overflowY: 'scroll'
                        }}
                      >
                        <div className="form-control-info">
                          <span className='custom_label'>Product Name</span>
                          <div className="custom_info_select_new" style={{border: 'none', fontWeight: 500}}>
                            {name}
                          </div>
                          <span className='custom_label'>Product Description</span>
                          <div className="custom_info_select_new" style={{border: 'none'}}>
                            {description}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className='col-md-12 mt-2'>
                        <div className='prev_next_block'>
                          <Button type='button' onClick={handleCancel} className="previous_btn">
                            Cancel
                          </Button>
                          {/* <Button className="next_btn_blue">
                            Next
                          </Button> */}
                          <button className='next_btn_blue'>Next</button>
                        </div>
                      </div>
                    </div>
                  </Form>

                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
